import type { ReactNode } from "react";
import { Button, Dialog, vars } from "@pack-it-up/ui-web";

// Confirm dialog before destructively clearing packed items.
export const ClearCheckedDialog = ({ open, onClose, onConfirm }: { open: boolean; onClose: () => void; onConfirm: () => void }): ReactNode => (
  <Dialog
    open={open}
    onClose={onClose}
    title="Clear checked items?"
    compact
    footer={
      <span style={{ display: "flex", justifyContent: "flex-end", gap: vars.space.sm }}>
        <Button variant="ghost" size="sm" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="danger"
          size="sm"
          onClick={() => {
            onClose();
            onConfirm();
          }}
        >
          Clear checked
        </Button>
      </span>
    }
  >
    This removes every packed item from the list. This can&apos;t be undone.
  </Dialog>
);
